import { toastr } from 'react-redux-toastr';
import { FUEL_DAILY_OPERATIONAL_DASHBOARD_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_FUEL_DAILY_OPERATIONAL_DASHBOARD,
  FLAG_FUEL_DAILY_OPERATIONAL_DASHBOARD_ACTIVITY,
  POST_FUEL_DAILY_OPERATIONAL_DASHBOARD,
} from '../types';

const flagFuelDailyOperationalDashboardActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_FUEL_DAILY_OPERATIONAL_DASHBOARD_ACTIVITY,
    payload: flag,
  });

const postFuelDailyOperationalDashboard =
  (payloadIn) =>
  async (dispatch) => {
    try {
      dispatch(flagFuelDailyOperationalDashboardActivity(true));
      const payload = {
        fromDate: String(payloadIn.fromDate),
        toDate: String(payloadIn.toDate),
      };
      if (payloadIn.companyBusIds && payloadIn.companyBusIds.length > 0) {
        payload.companyBusIds = payloadIn.companyBusIds;
      }
      if (payloadIn.circuitId != null && payloadIn.circuitId !== '') {
        payload.circuitId = Number(payloadIn.circuitId);
      }
      if (
        payloadIn.homeBaseLocationId != null &&
        payloadIn.homeBaseLocationId !== ''
      ) {
        payload.homeBaseLocationId = Number(payloadIn.homeBaseLocationId);
      }
      if (payloadIn.statuses && payloadIn.statuses.length > 0) {
        payload.statuses = payloadIn.statuses;
      }
      if (payloadIn.includeNorthChicoRoutes != null) {
        payload.includeNorthChicoRoutes = Boolean(payloadIn.includeNorthChicoRoutes);
      }
      const response = await fetch(FUEL_DAILY_OPERATIONAL_DASHBOARD_ENDPOINT, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const report = await response.json();
      dispatch({
        type: POST_FUEL_DAILY_OPERATIONAL_DASHBOARD,
        payload: report,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagFuelDailyOperationalDashboardActivity(false));
    }
  };

const clearFuelDailyOperationalDashboard = () => (dispatch) =>
  dispatch({
    type: CLEAR_FUEL_DAILY_OPERATIONAL_DASHBOARD,
  });

export {
  flagFuelDailyOperationalDashboardActivity,
  postFuelDailyOperationalDashboard,
  clearFuelDailyOperationalDashboard,
};
